import {Reducer} from 'redux'
import {PaymentsActionTypes, PaymentsState} from './types';
import PaymentsService from "../../services/PaymentsService";

// Type-safe initialState!
const initialState: PaymentsState = {
	list: [],
	customerList: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<PaymentsState> = (state = initialState, action) => {
	switch (action.type) {
		case PaymentsActionTypes.FETCH_ALL_REQUEST: {
			PaymentsService.getAll()
			return { ...state, loading: true }
		}
		case PaymentsActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case PaymentsActionTypes.FETCH_ONE_REQUEST: {
			PaymentsService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case PaymentsActionTypes.FETCH_ONE_COMPLETED: {
			// updates list but I do not see usage of this at the moment
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case PaymentsActionTypes.SAVE_REQUEST: {
			PaymentsService.save(action.payload)
			return { ...state, loading: true }
		}
		case PaymentsActionTypes.SAVE_COMPLETED: {
			let newItem = action.payload
			let foundIndex = state.list.findIndex(element => element.id === newItem.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, list: newList}
		}
		case PaymentsActionTypes.DELETE_REQUEST: {
			PaymentsService.delete(action.payload)
			return { ...state, loading: true }
		}
		case PaymentsActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case PaymentsActionTypes.DELETE_MULTIPLE_REQUEST: {
			PaymentsService.deletePayments(action.payload)
			return { ...state, loading: true }
		}
		case PaymentsActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case PaymentsActionTypes.FETCH_BY_CUSTOMER_REQUEST:
			PaymentsService.getByCustomer(action.payload)
			return state;
		case PaymentsActionTypes.FETCH_BY_CUSTOMER_COMPLETED:
			return { ...state, customerList: action.payload}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as PaymentsReducer}
